import React from 'react';
import './Header.css';
import { API_ENV, BASE_URL } from '../api';

const Header = () => {
  return (
    <header className="app-header">
      <div className="header-content">
        <img src={process.env.PUBLIC_URL + '/logo192.png'} alt="Nexus Logo" className="header-logo" />
        <h1 className="header-title">Nexus</h1>
        {API_ENV === 'dev' && (
          <span className="api-env-badge" title={BASE_URL}>
            DEV API
          </span>
        )}
      </div>
    </header>
  );
};

export default Header; 
